
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui/Spinner";

interface PhotoUrlInputProps {
  value: string;
  onChange: (value: string) => void;
  onUpdate: () => void;
  isLoading: boolean;
}

export const PhotoUrlInput = ({ value, onChange, onUpdate, isLoading }: PhotoUrlInputProps) => {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Photo URL</label>
      <Input
        type="text"
        placeholder="Enter photo URL"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <Button 
        onClick={onUpdate}
        disabled={isLoading}
        className="w-full"
      >
        {isLoading ? (
          <>
            <Spinner size="sm" className="mr-2" ariaLabel="Updating" />
            Updating...
          </>
        ) : (
          'Update URL'
        )}
      </Button>
    </div>
  );
};
